import $ from 'jquery';

// requiestAnimationFrame reference or polyfill
var requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();

// Point to polygon test
function __pointInPolygon(point, polygon) {
  var hits = false,
      j = polygon.length - 1;

  for (var i = 0; i < polygon.length; i++) {
    if ((polygon[i][1] < point[1] && polygon[j][1] >= point[1]
    || polygon[j][1] < point[1] && polygon[i][1] >= point[1])
    && (polygon[i][0] <= point[0] || polygon[j][0] <= point[0])) {
      hits ^= (polygon[i][0] + (point[1] - polygon[i][1]) / (polygon[j][1] - polygon[i][1]) * (polygon[j][0] - polygon[i][0]) < point[0]);
    }
    j = i;
  }

  return hits;
}

// Get coordinates from flexible parameters
function __flexParam(x, y) {
  var coords;
  if (typeof x === "number" && y) {
    coords = [x, y];
  } else if (x instanceof Array) {
    coords = x;
  } else {
    throw new TypeError('Unexpected parameters');
  }

  return coords;
}


/**
 * ImageCache
 */

function ImageCache() {
  this.cache = {};
}

ImageCache.prototype.isLoaded = function (url) {
  return !!this.cache[url];
};

ImageCache.prototype.getImage = function (url, callback, error) {
  var self = this,
      element;

  if (!this.isLoaded(url)) {
    element = document.createElement('img');
    element.onload = function (ev) {
      self.cache[url] = element;
      if (typeof callback === 'function') {
        callback(element);
      }
    };
    element.onerror = function () {
      if (typeof error === 'function') {
        error();
      }
    };
    element.src = url;
  } else if (typeof callback === 'function') {
    element = document.createElement('img');
    element.src = url;
    callback(element);
  }
};

ImageCache.prototype.getImages = function (urls, callback) {
  var loaded = 0,
      willLoad = urls.length;

  if (!urls instanceof Array) {
    throw new TypeError('First parameter should be array');
  }

  for (var i = 0; i < urls.length; i++) {
    this.getImage(urls[i], function () {
      loaded++;
      if (loaded == willLoad
          && typeof callback === 'function') {
        callback(true);
      }
    }, function () {
      callback(false);
    });
  }
};

var imageCache = new ImageCache();
window.imageCache = imageCache;

/**
 * Loading indicator
 */

function LoadIndicator() {
  this.$el = $('<div>');
  this.$el.addClass('load-indicator');

  this.$el.hide();

  this.opts = {
    lines: 13,
    length: 4,
    width: 2,
    radius: 8,
    corners: 1,
    rotate: 0,
    direction: 1,
    color: '#000',
    speed: 1.3,
    trail: 60,
    shadow: false,
    hwaccel: false,
    className: 'spinner'
  };

  this.spinner = new Spinner(this.opts);
}

LoadIndicator.prototype.getElement = function () {
  return this.$el;
};

LoadIndicator.prototype.activate = function () {
  if (this.isActive === true) return;

  this.spinner.spin(this.$el[0]);
  this.$el.velocity('fadeIn', { duration: 150 });
  this.isActive = true;
};

LoadIndicator.prototype.disable = function () {
  if (this.isActive === false) return;

  var self = this;

  this.$el.velocity('fadeOut', {
    duration: 150,
    complete: function () {
      self.spinner.stop();
    }
  });

  this.isActive = false;
};


/**
 * Overview
 */

function Overview(el) {
  this.$el = $(el);
  this.$parent = this.$el.parent();

  var self = this;

  // Load indicator
  this.loadIndicator = new LoadIndicator();
  this.$el.prepend(this.loadIndicator.getElement());
  this.loadIndicator.activate();

  this.assetRoot = this.$el.attr('data-asset-root');

  this.defaultPos = {
    zoom: 0.4,
    x: 780,
    y: 700
  };

  // Insert image element
  this.$image = $('<div class="js-image"></div>')
    .css('transform-origin', '0 0');
  this.$el.prepend(self.$image);

  // Insert canvas element
  this.$canvas = $('<canvas></canvas>')
    .attr({
      width: 936, // 936, // 1872, //468,
      height: 808 // 808 // 1615, //404,
    })
    .css('opacity', 0);
  this.canvas = this.$canvas[0];
  this.$image.append(this.$canvas);
  this.ctx = this.$canvas[0].getContext('2d');

  // Insert close button
  this.$close = $('<a href="#">&times;</a>')
    .addClass('close-button is-hidden');
  this.$el.append(this.$close);

  // Insert number of seats interface element
  this.$seats = $('<div></div>')
    .addClass('number-of-seats')
    .hide();
  this.$el.append(this.$seats);

  (function animate () {
    requestAnimFrame(animate);
    self.drawCanvas();
  }());

  // Save areas
  this.areas = [];
  this.$el.find('.js-area[data-map]').each(function () {
    var $this = $(this),
        $el,
        area,
        map,
        seats,
        center = [0, 0],
        top,
        left,
        right,
        bottom;

    try {
      map = JSON.parse($this.attr('data-map'));

      if (map instanceof Array) {
        for (var i = 0; i < map.length; i++) {

          if (!top || map[i][1] < top) {
            top = map[i][1];
          }

          if (!left || map[i][0] < left) {
            left = map[i][0];
          }

          if (!bottom || map[i][1] > bottom) {
            bottom = map[i][1];
          }

          if (!right || map[i][0] > right) {
            right = map[i][0];
          }
        }

        center[0] = (left + right) / 2;
        center[1] = (top + bottom) / 2;
      }
    } catch (e) {
      map = false;
      center = false;
    }

    try {
      seats = JSON.parse($this.attr('data-seats'));
    } catch (e) {
      seats = false;
    }

    area = {
      id: $this.attr('data-id'),
      $el: $this,
      $area: $('<img>'),
      el: this,
      active: false,
      map: map,
      seats: seats,
      center: center,
      arrangements: $this.attr('data-arrangements')
    };

    self.areas.push(area);

    $this.on('click', function (ev) {
      ev.preventDefault();
      self.activateArea(area);
    });
  });

  // Save arrangements
  this.arrangements = [];
  this.$el.find('.js-arrangements .arrangement[data-asset]').each(function () {
    var $this = $(this),
        arrangement,
        asset;

    arrangement = {
      $el: $this,
      id: $this.attr('data-id'),
      group: $this.attr('data-group'),
      asset: $this.attr('data-asset')
    };

    self.arrangements.push(arrangement);

    if (arrangement.group !== 'default') {
      $this.hide();
    }

    $this.on('click', function (ev) {
      ev.preventDefault();
      self.activateArrangement(arrangement);
    });
  });

  // Activate the first arrangement
  if (typeof this.arrangements[0] === 'object') {
    self.activateArrangement(this.arrangements[0]);
  }
  this.showArrangementGroup('default');

  this.viewportHeight = this.$el.height();
  this.viewportWidth = this.$el.width();

  this.zoom = 1.0;

  // Hook up events
  this.$image.on('click', function (ev) {
    self.handleClick(ev);
  });

  this.$image.on('mousemove', function (ev) {
    self.handleMousemove(ev);
  });

  this.$close.on('click', function (ev) {
    ev.preventDefault();
    self.activateArea(false);
  });

  /* todo:debounce */
  $(window).on('load resize', function (ev) {
    self.viewportHeight = self.$el.height();
    self.viewportWidth = self.$el.width();

    if (self.currentArea) {
      self.repositionAt(1, self.currentArea.center, self.currentArea.center, true);
    } else {
      self.repositionAt(self.defaultPos.zoom, self.defaultPos.x, self.defaultPos.y, true);
    }

    self.defaultPos.zoom = self.viewportWidth < 960 ? 0.2 : 0.4;

  }).resize();

  // Set original position
  this.repositionAt(this.defaultPos.zoom, this.defaultPos.x, this.defaultPos.y, true);
}


/**
 * object{x, y} coordsMapToScreen (array[x, y]|int x, int y)
 *
 * Translate map-space coords x, y to screen-space equivalents.
 * Accepts separate parameters or array of coordinates.
 */

Overview.prototype.coordsMapToScreen = function (x, y) {
  var coords = __flexParam(x, y);

  for (var i = coords.length - 1; i >= 0; i--) {
    coords[i] = coords[i] * this.zoom;
  }

  return {
    x: coords[0],
    y: coords[1]
  };
};


/**
 * void repositionAt (array[x, y]|int x, int y)
 *
 * Reposition the map at map-space coordinates x, y.
 */

Overview.prototype.repositionAt = function (zoom, x, y, dontAnimate) {
  var coords = __flexParam(x, y), modifier;

  zoom = zoom || 1;
  this.zoom = zoom;

  dontAnimate = dontAnimate || false;

  // Screen space coords:
  coords = this.coordsMapToScreen(coords);

  // Modifiers
  modifier = {
    x: window.innerWidth > 740 ? 150 : 0,
    y: 0
  };

  // Center in viewport:
  coords = {
    x: (this.viewportWidth / 2 / zoom) - coords.x / zoom + modifier.x / zoom,
    y: (this.viewportHeight / 2 / zoom) - coords.y / zoom + modifier.y / zoom
  };

  this.$image.velocity("stop").velocity({
    scale: zoom,
    translateX: coords.x,
    translateY: coords.y
  }, {
    duration: dontAnimate ? 0 : 660,
    easing: 'easeOutCubic'
  });
};


/**
 * void activateArea (bool|object area)
 */

Overview.prototype.activateArea = function (area) {
  if (this.currentArea === area) {
    return;
  }

  $('.js-areas .js-area').removeClass('is-selected');

  if (area === false) {
    this.repositionAt(this.defaultPos.zoom, this.defaultPos.x, this.defaultPos.y);
    this.currentArea = false;
    this.showArrangementGroup('default');
    this.$canvas.velocity({
      opacity: 0
    }, {
      duration: 300
    });
    this.$close.addClass('is-hidden');
  } else {
    this.repositionAt(window.innerWidth < 460 ? 0.66 : 1, area.center[0], area.center[1]);
    this.currentArea = area;
    area.$el.addClass('is-selected');
    this.showArrangementGroup(area.arrangements);
    this.$canvas.velocity({
      opacity: 0.88
    }, {
      duration: 300
    });
    this.$close.removeClass('is-hidden');
  }

  this.reloadSeats();
};


/**
 * void activateArrangement(object arrangement)
 */

Overview.prototype.activateArrangement = function (arrangement) {
  var self = this;

  this.currentArrangement = this.currentArrangement || false;

  $('.js-arrangements .js-arrangement').removeClass('is-selected');
  arrangement.$el.addClass('is-selected');

  if (this.currentArrangement && this.currentArrangement.id === arrangement.id) {
    return;
  }

  if (!imageCache.isLoaded(this.assetRoot + arrangement.asset)) {
    this.loadIndicator.activate();
  }

  imageCache.getImage(this.assetRoot + arrangement.asset, function (image) {
    var oldImage = self.$image.find('img');

    if (oldImage.length > 0) {
      oldImage.remove();
    }

    var newImage = $(image);

    self.$image.append(newImage);
    self.loadIndicator.disable();
    self.currentArrangement = arrangement;
    image = null;

    self.reloadSeats();
  }, function () {
    self.loadIndicator.disable();
  });
};


/**
 * void reloadSeats(reloadSeats)
 *
 * Recalculates the number of seats based on current area and arrangement
 */

Overview.prototype.reloadSeats = function () {
  var numberOfSeats;

  if (this.currentArrangement
        && this.currentArea
        && this.currentArea.seats
        && this.currentArrangement.id in this.currentArea.seats) {

    numberOfSeats = this.currentArea.seats[this.currentArrangement.id];

    var seatsText = 'Max ' + numberOfSeats + ' sittplatser';
    if (window.P5_STRINGS && window.P5_STRINGS.seatsText) {
      seatsText = window.P5_STRINGS.seatsText.replace('%i', numberOfSeats);
    }

    this.$seats.text(seatsText);

    if (!this.numberOfSeatsActive) {
      this.$seats
        .velocity('stop')
        .velocity('slideDown', {
          duration: 100
        })
    }

    this.numberOfSeatsActive = true;
  } else {
    this.$seats.velocity('stop').velocity('slideUp', {
      duration: 100,
      complete: function () {
        $(this).empty();
      }
    });
    this.numberOfSeatsActive = false;
  }
};


/**
 * void showArrangementGroup(string name)
 *
 * Show a certain group of arrangements based on string name.
 */

Overview.prototype.showArrangementGroup = function (name) {
  var firstVisibleArrangement = false;
  this.arrangementGroup = this.arrangementGroup || name;

  if (name === 'none') {
    this.$el.find('.js-arrangements-header').hide();
    this.$el.find('.js-arrangements > .js-arrangement').hide();
  } else {
    this.$el.find('.js-arrangements-header').show();
    $.each(this.arrangements, function (i, arrangement) {
      if (arrangement.group === name) {
        if (!firstVisibleArrangement) {
          firstVisibleArrangement = arrangement;
        }
        arrangement.$el.show();
      } else {
        arrangement.$el.hide();
      }
    });
  }

  if (this.arrangementGroup !== name
      && firstVisibleArrangement) {
    this.activateArrangement(firstVisibleArrangement);
  }

  this.arrangementGroup = name;
};


/**
 * void handleClick (event ev)
 *
 * Handles a click event on the element.
 */

Overview.prototype.handleClick = function (ev) {
  var self = this,
      was_hit = false,
      clickAt = {
        x: ev.offsetX || ev.originalEvent.layerX,
        y: ev.offsetY || ev.originalEvent.layerY
      };

  console.time('click');

  $.each(this.areas, function (i, area) {
    var test = __pointInPolygon([clickAt.x, clickAt.y], area.map);
    if (test > 0) {
      self.activateArea(area);
      was_hit = true;
      return false;
    }
  });

  console.timeEnd('click');

  if (!was_hit) {
    self.activateArea(false);
  }
};


/**
 * void handleMousemove (event ev)
 *
 * todo: needs serious debouncing
 */

Overview.prototype.handleMousemove = function (ev) {
  var self = this,
      was_hit = false,
      mouseAt = {
        x: ev.offsetX || ev.originalEvent.layerX,
        y: ev.offsetY || ev.originalEvent.layerY
      };

  $.each(this.areas, function (i, area) {
    var test = __pointInPolygon([mouseAt.x, mouseAt.y], area.map);
    if (test > 0) {
      self.$image.css('cursor', 'pointer');
      was_hit = true;
      return false;
    }
  });

  if (!was_hit) {
    self.$image.css('cursor', 'default');
  }
};


/**
 * void drawCanvas()
 *
 * Draw the canvas. Coordinates in this function should be half
 * the map-space coordinates.
 */

Overview.prototype.drawCanvas = function () {
  var ctx = this.ctx,
      width = this.canvas.width,
      height = this.canvas.height,
      map;

  if (this.currentArea && this.currentArea.map instanceof Array) {

    ctx.clearRect(0, 0, width, height);
    ctx.globalCompositeOperation = "xor";

    map = this.currentArea.map;

    ctx.fillStyle = '#f2f2f2';
    ctx.fillRect(0, 0, width, height);

    ctx.save();
    ctx.beginPath();
    ctx.fillStyle = '#000';
    ctx.moveTo(map[0][0] / 2, map[0][1] / 2);
    for (var i = 1; i < map.length; i++) {
      ctx.lineTo(map[i][0] / 2, map[i][1] / 2);
    }
    ctx.closePath();
    ctx.fill();

    ctx.restore();
  }
};


/**
 * Make instances
 */

$(function () {
  var $overview = $('.js-overview');
  if ($overview.length === 1 && Modernizr.csstransforms) {
    var overview = new Overview($overview);
  }

  window.P5 = window.P5 || {};
  window.P5.overview = overview || false;
});
